import { CommonModule } from '@angular/common';
import { Component, input, OnInit, output } from '@angular/core';
import { DomSanitizer, SafeHtml, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-smart-fix-video-player',
  standalone: true,
  templateUrl: './smart-fix-video-player.component.html',
  styleUrls: ['./smart-fix-video-player.component.scss'],
  imports: [CommonModule],
})
export class VideoPlayerComponent implements OnInit {
  safeVideoUrl!: SafeResourceUrl;
  safeDescription!: SafeHtml;
  videoUrl = input<string>('');
  description = input<string>('');
  offset = input<number>(0);
  closed = input<boolean>(false);
  watchedVideo = output<boolean>();
  videoClicked = output<boolean>();
  videoLoaded = output<boolean>();

  constructor(private domSanitizer: DomSanitizer) {}

  ngOnInit() {
    if (this.videoUrl) {
      // Extract video ID and timestamp
      const videoIdMatch = this.videoUrl().match(/(?:v=|\/)([a-zA-Z0-9_-]{11})(?:[&?]t=(\d+))?/);

      if (videoIdMatch) {
        const videoId = videoIdMatch[1];
        const timestamp = videoIdMatch[2] || this.offset();

        const embedUrl = `https://www.youtube.com/embed/${videoId}?start=${timestamp}`;
        this.safeVideoUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(embedUrl);
      }
    }

    if (this.description) {
      this.safeDescription = this.domSanitizer.bypassSecurityTrustHtml(this.description());
    }
  }

  onVideoClick() {
    this.videoClicked.emit(true);
  }

  submitVideoWatched() {
    this.watchedVideo.emit(true);
  }

  onVideoLoaded() {
    this.videoLoaded.emit(true);
  }
}
